'use client'

import React from 'react'
import isMobile from 'ismobilejs'
import dynamic from 'next/dynamic'
import { ContentViewType, ScrollType } from './helpers'

const MobileView = dynamic(() => import('./components/MobileView'), { ssr: false })
const DesktopView = dynamic(() => import('./components/DesktopView'), { ssr: false })
const CarousalView = dynamic(() => import('./components/CarousalView'), { ssr: false })

interface AckoEdgeProps {
  title: string
  EdgeBenefitList: any
  heroVideo: any
  actionText: string
  formSnippet: any
  insuranceName: string
  contentViewType: ContentViewType
}

const AckoEdge = (data: AckoEdgeProps) => {
  const isMobileDevice = isMobile()?.phone
  const contentViewType = data?.contentViewType || ContentViewType.ListView

  switch (contentViewType) {
    case ContentViewType.ListView:
      return isMobileDevice ? (
        <MobileView
          title={data?.title}
          EdgeBenefitList={data?.EdgeBenefitList}
          mainImage={data?.heroVideo?.url}
          actionText={data?.actionText}
          formSnippet={data?.formSnippet}
        />
      ) : (
        <DesktopView
          title={data?.title}
          EdgeBenefitList={data?.EdgeBenefitList}
          actionText={data?.actionText}
          formSnippet={data?.formSnippet}
          insuranceName={data?.insuranceName}
        />
      )
    case ContentViewType.CarousalAutoScroll:
      return (
        <CarousalView title={data?.title} EdgeBenefitList={data?.EdgeBenefitList} scrollType={ScrollType.AutoScroll} />
      )
    case ContentViewType.CarousalStatic:
      return <CarousalView title={data?.title} EdgeBenefitList={data?.EdgeBenefitList} scrollType={ScrollType.Static} />
    default:
      return isMobileDevice ? (
        <MobileView
          title={data?.title}
          EdgeBenefitList={data?.EdgeBenefitList}
          mainImage={data?.heroVideo?.url}
          actionText={data?.actionText}
          formSnippet={data?.formSnippet}
        />
      ) : (
        <DesktopView
          title={data?.title}
          EdgeBenefitList={data?.EdgeBenefitList}
          actionText={data?.actionText}
          formSnippet={data?.formSnippet}
          insuranceName={data?.insuranceName}
        />
      )
  }
}

export default AckoEdge
